var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    clipPath: "url(#clip0_20230_15000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99996 1.1665C3.77996 1.1665 1.16663 3.77984 1.16663 6.99984C1.16663 10.2198 3.77996 12.8332 6.99996 12.8332C10.22 12.8332 12.8333 10.2198 12.8333 6.99984C12.8333 3.77984 10.22 1.1665 6.99996 1.1665ZM7.58329 9.9165H6.41663V6.4165H7.58329V9.9165ZM7.58329 5.24984H6.41663V4.08317H7.58329V5.24984Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20230_15000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9c9369ab042b680ec7291ec02e5d005f.svg";
export { ForwardRef as ReactComponent };